import styles from "./styles.module.css";
import StaggeredList, { IStaggeredListItem } from "../StaggeredList";
import DropSelect from "../DropSelect";
import { MutableRefObject } from "react";
import { IUploadPopUpRef } from "../UploadPopUp";
import useOtherCategory from "@/hooks/useOtherCategory";
import {
  createEmptyEditorJob,
  createPage,
  getJobDetails,
  savePage,
} from "@/modules/editor-v2/services/Jobs";
import { useRouter } from "next/router";
import DMSCanvas from "local_modules/editor/src/DMSCanvas";
import { getTemplate } from "@/modules/editor-v2/services/MyWorks";
import { calcProductImageDimensionsAndPosition } from "@/hooks/useEditorService";
import { IBoundingBox } from "@/modules/ui-elements/TemplatePreview";
import { TrackWebappEvent } from "src/modules/segment-event-tracking/segmentEventTracking";
import { EventTrackName } from "src/modules/segment-event-tracking/constant";
import { useAtomValue, useSetAtom } from "jotai";
import {
  segmentEventPayload,
  homepageFeatureAtom,
  activeProjectAtom,
} from "src/modules/editor-v2/Atoms";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import DropSelectSkeleton from "../DropSelect/DropSelectSkeleton";

interface ISocialMediaProps {
  popUpRef: MutableRefObject<IUploadPopUpRef>;
}

export default function SocialMedia({ popUpRef }: ISocialMediaProps) {
  const { otherCategory, otherSubCategory } = useOtherCategory();
  const router = useRouter();
  const setHomepageFeature = useSetAtom(homepageFeatureAtom);
  const setActiveProject = useSetAtom<any>(activeProjectAtom);
  const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
  const strapiData: any = useSelector<any>(
    (state) =>
      state.strapi?.entireStrapiData?.WebappHomepageV22?.WebappHomepageV22
  );
  const strapiData2:any = useSelector<any>(state=>state.strapi?.entireStrapiData?.StaggeredListItemType?.StaggeredListItemType);
  const socialMediaList: any = useSelector<any>((state) =>
    state.strapi?.entireStrapiData?.StaggeredListItemType?.StaggeredListItemType?.ListItemType?.map((item) => ({
      ...item,
      extraData: {
        height: parseInt(item?.extraData?.height),
        width: parseInt(item?.extraData?.width),
      },
    }))
  );

  const addAssetForSocialMedia = async (asset, jobId, item) => {
    let { templateId, imageId } = await createPage(jobId);
    console.log(item);
    let canvasEl = document.createElement("canvas");
    canvasEl.id = "hidden-canvas-" + imageId;
    canvasEl.style.position = "absolute";
    canvasEl.style.left = "-9999px";
    document.body.appendChild(canvasEl);
    const canvas = new DMSCanvas(
      "hidden-canvas-" + imageId,
      {
        height: 500,
        width: 500,
      },
      { height: item.extraData?.height, width: item.extraData.width }
    );
    const template = await getTemplate(templateId);
    // const backgroundPromise = canvas.setBackgroundFromURL(template.jpg_file);
    const productImageFabricRef = await canvas.addImageFromUrl({
      imageUrl: asset?.url,
      dimensions: {
        height: item?.extraData?.height,
        width: item?.extraData?.width,
      },
    });
    const productImageDimensions = {
      height: productImageFabricRef.height,
      width: productImageFabricRef.width,
    };
    const boundingBox: IBoundingBox = {
      height: item?.extraData?.height * 0.8,
      width: item?.extraData?.width * 0.8,
      horizontalJustification: "center",
      verticalJustification: "center",
      xOffset: item?.extraData?.width * 0.1,
      yOffset: item?.extraData?.height * 0.1,
      rotation: 0,
    };
    const { position, dimensions } = calcProductImageDimensionsAndPosition(
      productImageDimensions,
      boundingBox,
      1,
      1
    );
    const productLayer = await canvas.getLayerByRef(productImageFabricRef);
    productLayer.setDimensions(dimensions);
    productLayer.setPosition(position);
    productLayer.addTag("product-image");
    productLayer.addTag("product-asset-id-" + asset?._id);
    // await backgroundPromise;
    const dmsFile = await canvas.save();
    await savePage(imageId, dmsFile, "homePage");
    canvas.canvas.dispose();
    document.body.removeChild(canvasEl);
  };

  async function addPagesSynchronously(assets, jobId, item) {
    for (const asset of assets) {
      await addAssetForSocialMedia(asset, jobId, item);
    }
  }

  const onUploadSuccessGenerator = (item) => async (assets) => {
    const jobData = await createEmptyEditorJob(
      otherCategory?._id,
      otherSubCategory?._id
    );
    const jobId = jobData?.job_id;
    await addPagesSynchronously(assets, jobId, item);
    const project = await getJobDetails(jobId);
    if(!project || !project?.job_id) throw new Error("Invalid Project ID");
    setActiveProject(project);
    router.push("/dashboard/editor/" + jobId + "?assets");
  };

  const onItemClick = (item) => {
    setHomepageFeature(item.title);
    popUpRef.current.open({
      title: "Create For " + item.title,
      onUploadSuccess: onUploadSuccessGenerator(item),
      widgetImage: item.widgetImage,
    });
    const eventPayload = {
      homepageFeature: item.title,
      ...getSegmentPayloadAtom,
    };
    TrackWebappEvent(
      `${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._click_social_media_hp}`,
      eventPayload
    );
  };

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.heading}>
          {strapiData?.SocialMediaHeading || "Social Media"}
        </div>
      </div>
      {!socialMediaList && !socialMediaList?.length ? (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <DropSelectSkeleton />
        </div>
      ) : (
        <div>
          <DropSelect items={socialMediaList} dropDownTitle={strapiData2.SelectSocialMedia || 'Select Social Media'} onItemClick={onItemClick} />
        </div>
      )}
    </div>
  );
}

const list: IStaggeredListItem[] = [
  {
    image: "/icons/marketplace-icons/instagram-icon.png",
    title: "Instagram Post",
    background:
      "linear-gradient(135deg, rgba(182, 4, 238, 0.16) 0%, rgba(255, 167, 0, 0.16) 100%)",
    aspectRatio: 1,
    extraData: {
      height: 1080,
      width: 1080,
    },
  },
  {
    image: "/icons/marketplace-icons/instagram-icon.png",
    title: "Instagram Story",
    background:
      "linear-gradient(135deg, rgba(182, 4, 238, 0.16) 0%, rgba(255, 167, 0, 0.16) 100%)",
    aspectRatio: 2 / 3,
    extraData: {
      height: 1920,
      width: 1080,
    },
  },
  {
    image: "/icons/marketplace-icons/facebook-icon.png",
    title: "Facebook Cover",
    background: "rgba(141, 190, 255, 0.16)",
    aspectRatio: 3 / 2,
    extraData: {
      height: 1256,
      width: 2400,
    },
  },
  {
    image: "/icons/marketplace-icons/facebook-icon.png",
    title: "Facebook Post",
    background: "rgba(141, 190, 255, 0.16)",
    aspectRatio: 1,
    extraData: {
      height: 1080,
      width: 1080,
    },
  },
  {
    image: "/icons/marketplace-icons/linkedin-icon.png",
    title: "LinkedIn Banner",
    background: "rgba(0, 128, 255, 0.16)",
    aspectRatio: 9 / 4,
    extraData: {
      height: 1256,
      width: 2400,
    },
  },
  {
    image: "/icons/marketplace-icons/linkedin-icon.png",
    title: "LinkedIn Profile Picture",
    background: "rgba(0, 128, 255, 0.16)",
    aspectRatio: 1,
    extraData: {
      height: 1080,
      width: 1080,
    },
  },
  {
    image: "/icons/marketplace-icons/whatsapp-icon.png",
    title: "Whatsapp Story",
    background: "rgba(95, 246, 122, 0.16)",
    aspectRatio: 1,
    extraData: {
      height: 1920,
      width: 1080,
    },
  },
];
